/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toast_Discount_Rule_DeletedInputs */

const vi_toast_discount_rule_deleted = /** @type {(inputs: Toast_Discount_Rule_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã xóa quy tắc chiết khấu`)
};

/**

* @param {Toast_Discount_Rule_DeletedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const toast_discount_rule_deleted = /** @type {((inputs?: Toast_Discount_Rule_DeletedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toast_Discount_Rule_DeletedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_toast_discount_rule_deleted(inputs)
});